export const navItems = ['Destinations', 'Space Trains', 'Pricing', 'Packages'];

export const col1 = ['About Us', ' Destinations', 'Spacecraft'];
export const col2 = ['Terms of Service', 'Privacy Policy', 'Refund Policy'];
export const col3 = ['Travel', 'Rail'];
export const social = [
  '/img/facebook.svg',
  '/img/instagram.svg',
  '/img/twitter.svg',
  '/img/linkedin.svg',
];

export const sections = [
  {
    image: '/img/unsplash.jpg',
    title: 'Perseverance Rover Discovers Ancient Riverbed on Saturn',
    body: "The discovery of the ancient riverbed comes from Perseverance's analysis of rock layers in the delta. The sedimentary rocks are thought to have formed over billions of years as silt and clay settled in the calm waters of the river delta. This environment could have provided favorable conditions for the development and preservation of microbial life, if it ever existed on Mars.",
  },
];

export const cards = [
  {
    image: '/img/card1.webp',
    title: 'Welcome to Space News',
    body: 'Explore the cosmos through our lens. Stay updated with the latest space discoveries, astronomical events, and interstellar adventures.',
    buttonText: 'Read Nowt',
    variant: 'primary',
  },
  {
    image: '/img/card2.webp',
    title: "NASA's New Mission to Jupiter's Moons",
    body: "NASA announces an upcoming mission to explore Europa and Ganymede, two of Jupiter's fascinating moons.",
    buttonText: 'Read More',
    variant: 'primary',
  },
  {
    image: '/img/card3.webp',
    title: 'Exploring the Mysteries of primary Holes',
    body: 'Dive into the enigmatic world of primary holes, where the laws of physics break down, and time and space warp.',
    buttonText: 'Read Article',
    variant: 'primary',
  },
];

export const news = [
  {
    image: '/img/card1.webp',
    title: "NASA's Perseverance Rover Discovers Ancient Riverbed on Mars",
    body: "This is a significant milestone in our quest to understand the history of water on Mars and, importantly, whether the planet ever supported life,\" said Dr. Sarah Johnson, a planetary geologist at NASA's Jet Propulsion Laboratory.\nScientists are excited about the potential of the rock samples Perseverance will collect from this region. These samples may hold clues about Mars' ancient climate and whether it was ever habitable. Future missions to Mars, including sample return missions, will play a crucial role in unlocking the secrets of the Red Planet.\nNASA's Perseverance rover continues to make groundbreaking discoveries on Mars, and each new finding brings us closer to answering the age-old question: Is there, or was there ever, life on Mars?",
    variant: 'purple',
    buttonText: 'Learn More',
  },
  {
    image: '/img/card3.webp',
    title: 'Our Space Train Fleet',
    body: 'Travel in style and comfort aboard our luxury space trains. Our fleet is equipped with cutting-edge technology to ensure a safe and unforgettable cosmic journey',
    variant: 'purple',
    buttonText: 'View Destinations',
    flip: true,
  },
];
